export default "__VITE_ASSET__CDEYRCN6__"